import React, { useEffect, useState } from 'react';

const Toast = ({ id, message, type, onRemove, duration = 5000 }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => onRemove(id), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onRemove]);

  return (
    <div
      className={`
        toast-item
        ${type === 'success' ? 'toast-success' : 'toast-error'}
        ${isExiting ? 'toast-exit' : 'toast-enter'}
      `}
    >
      {/* 줄바꿈(\n)을 살린다 — CSV 실패처럼 «몇 번 줄·무엇 + 영어»를 여러 줄로 보여 줄 때(2026-10-07) */}
      <div className="toast-content" style={{ whiteSpace: 'pre-line' }}>
        {message}
      </div>
      <div className="toast-progress-bar" style={{ animationDuration: `${duration}ms` }} />
    </div>
  );
};

export default Toast;
